/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppendixId } from './AppendixId';
import {
    AppendixIdFromJSON,
    AppendixIdFromJSONTyped,
    AppendixIdToJSON,
} from './AppendixId';
import type { MetadataField } from './MetadataField';
import {
    MetadataFieldFromJSON,
    MetadataFieldFromJSONTyped,
    MetadataFieldToJSON,
} from './MetadataField';
import type { Receiver } from './Receiver';
import {
    ReceiverFromJSON,
    ReceiverFromJSONTyped,
    ReceiverToJSON,
} from './Receiver';

/**
 * 
 * @export
 * @interface CreateSignRequestWithTemplateData
 */
export interface CreateSignRequestWithTemplateData {
    /**
     * The reference number for the sign request
     * @type {string}
     * @memberof CreateSignRequestWithTemplateData
     */
    referenceNumber: string;
    /**
     * The template id
     * @type {string}
     * @memberof CreateSignRequestWithTemplateData
     */
    templateId: string;
    /**
     * Fallback email subject if the template does not have one. The orderNo (referenceNumber) is appended automatically.
     * @type {string}
     * @memberof CreateSignRequestWithTemplateData
     */
    emailSubject?: string;
    /**
     * The envelope metadata
     * @type {Array<MetadataField>}
     * @memberof CreateSignRequestWithTemplateData
     */
    metadata?: Array<MetadataField>;
    /**
     * The list of signers and receivers for the document
     * @type {Array<Receiver>}
     * @memberof CreateSignRequestWithTemplateData
     */
    receivers: Array<Receiver>;
    /**
     * The list of appendix ids
     * @type {Array<AppendixId>}
     * @memberof CreateSignRequestWithTemplateData
     */
    appendixIds?: Array<AppendixId>;
}

/**
 * Check if a given object implements the CreateSignRequestWithTemplateData interface.
 */
export function instanceOfCreateSignRequestWithTemplateData(value: object): boolean {
    if (!('referenceNumber' in value)) return false;
    if (!('templateId' in value)) return false;
    if (!('receivers' in value)) return false;
    return true;
}

export function CreateSignRequestWithTemplateDataFromJSON(json: any): CreateSignRequestWithTemplateData {
    return CreateSignRequestWithTemplateDataFromJSONTyped(json, false);
}

export function CreateSignRequestWithTemplateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSignRequestWithTemplateData {
    if (json == null) {
        return json;
    }
    return {
        
        'referenceNumber': json['referenceNumber'],
        'templateId': json['templateId'],
        'emailSubject': json['emailSubject'] == null ? undefined : json['emailSubject'],
        'metadata': json['metadata'] == null ? undefined : ((json['metadata'] as Array<any>).map(MetadataFieldFromJSON)),
        'receivers': ((json['receivers'] as Array<any>).map(ReceiverFromJSON)),
        'appendixIds': json['appendixIds'] == null ? undefined : ((json['appendixIds'] as Array<any>).map(AppendixIdFromJSON)),
    };
}

export function CreateSignRequestWithTemplateDataToJSON(value?: CreateSignRequestWithTemplateData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'referenceNumber': value['referenceNumber'],
        'templateId': value['templateId'],
        'emailSubject': value['emailSubject'],
        'metadata': value['metadata'] == null ? undefined : ((value['metadata'] as Array<any>).map(MetadataFieldToJSON)),
        'receivers': ((value['receivers'] as Array<any>).map(ReceiverToJSON)),
        'appendixIds': value['appendixIds'] == null ? undefined : ((value['appendixIds'] as Array<any>).map(AppendixIdToJSON)),
    };
}

